var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 164,
    fill: "none",
    viewBox: "0 0 170 164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 95,
    x: 41,
    y: 26,
    fill: "currentColor",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m163 136-8.373-19H137l26 19Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 100,
    x: 21,
    y: 44,
    fill: "var(--black)",
    rx: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 95,
    x: 11,
    y: 52,
    fill: "currentColor",
    rx: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14 164 8.373-19H40l-26 19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--black)",
    d: "M22 74h106v9H22zm0 23h84v9H22zm0 24h73v9H22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--black)",
    d: "m51.5 0 11.563 35.586h37.416l-30.27 21.993L81.77 93.164 51.5 71.171 21.23 93.164 32.79 57.58 2.521 35.586h37.416L51.5 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m52 24 6.286 19.347H78.63L62.172 55.305l6.286 19.348L52 62.695 35.542 74.653l6.286-19.348L25.37 43.347h20.344L52 24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.307cd2f7a489d4af0b4dbbdb4ad0a135.svg";
export { ForwardRef as ReactComponent };